<script>
import { eventGroupState, isSelectedEventGroupLocked } from "@app/store/eventGroupStore.svelte.js";
import { projectState } from "@app/store/projectStore.svelte.js";
import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
import { editorState } from "@app/store/editorStore.svelte.js";
import shiftLineForward from "@cclib/functions/quill/shiftLineForward.js";
import getAvgTimePerWord from "@cclib/functions/events/getAvgTimePerWord.js";
import { toast } from "@zerodevx/svelte-toast";
import * as m from "@app/paraglide/messages.js";

const alignmentMap = {
    left: false,
    right: "right",
    center: "center",
};

let isDisabled = $derived(!eventGroupState[projectState.selected] ||
    eventGroupState[projectState.selected].selected.length === 0 ||
    eventGroupState[projectState.selected].selected[0] ===
        eventGroupState[projectState.selected].events.length - 1 ||
    isSelectedEventGroupLocked());

function shiftLineToNextEvent() {
    try {
        if (!eventGroupState[projectState.selected]) return;
        if (eventGroupState[projectState.selected].selected.length === 0)
            return;
        if (
            eventGroupState[projectState.selected].selected[0] ===
            eventGroupState[projectState.selected].events.length - 1
        )
            return;
        if (isSelectedEventGroupLocked()) {
            toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
            return;
        }

        eventGroupState[projectState.selected].selected = [
            eventGroupState[projectState.selected].selected[0],
        ];

        let res = shiftLineForward(
            eventGroupState[projectState.selected].events[
                eventGroupState[projectState.selected].selected[0]
            ],
            eventGroupState[projectState.selected].events[
                eventGroupState[projectState.selected].selected[0] + 1
            ],
        );

        eventGroupState[projectState.selected].events[
            eventGroupState[projectState.selected].selected[0]
        ].text = res.event1.text;

        eventGroupState[projectState.selected].events[
            eventGroupState[projectState.selected].selected[0] + 1
        ].text = res.event2.text;

        if (window.quillEditor) {
            let eventIndex = eventGroupState[projectState.selected].selected[0];
            let delta = window.quillEditor.clipboard.convert({ html: eventGroupState[projectState.selected].events[eventIndex].text });
            window.quillEditor.setContents(delta, "silent");
            window.quillEditor.formatLine(0,9999, 'align', eventGroupState[projectState.selected].events[eventIndex].alignment === 'left' ? '' : eventGroupState[projectState.selected].events[eventIndex].alignment, "silent");

            window.quillEditor.setSelection(window.quillEditor.getLength(), 0, "silent");
        }

        if (editorState.updateTimeOnEdit) {
            let currentEvent =
                eventGroupState[projectState.selected].events[
                    eventGroupState[projectState.selected].selected[0]
                ];
            let nextEvent =
                eventGroupState[projectState.selected].events[
                    eventGroupState[projectState.selected].selected[0] + 1
                ];

            if (
                currentEvent.start &&
                currentEvent.end &&
                nextEvent.start &&
                nextEvent.end
            ) {
                let avgTimePerWord = getAvgTimePerWord(currentEvent);
                let numberOfWordsInLastLineOfLastEvent = window.quillEditor
                    .getText(0)
                    .split("\n")
                    .pop()
                    .split(" ").length;
                if (avgTimePerWord > 0 && avgTimePerWord !== Infinity) {
                    eventGroupState[projectState.selected].events[
                        eventGroupState[projectState.selected].selected[0] + 1
                    ].start -=
                        avgTimePerWord * numberOfWordsInLastLineOfLastEvent;
                    eventGroupState[projectState.selected].events[
                        eventGroupState[projectState.selected].selected[0]
                    ].end -=
                        avgTimePerWord * numberOfWordsInLastLineOfLastEvent;
                }
            }
        }

        insertHistoryAction({
            name: "shift line", //action name
            eventGroup: projectState.selected,
            snapshots: [
                {
                    store: "eventGroupState",
                    value: JSON.stringify(eventGroupState),
                },
            ],
        });
    } catch (err) {
        console.log(err, err.message);
    }
}
</script>

<li class="nav-item" role="none" title={m.shift_line_forward_title()}>
    <a
        class="nav-link"
        href="#!/"
        role="button"
        id="shift-line-forward-btn"
        aria-label={m.shift_line_forward_aria_label()}
        class:disabled={isDisabled}
        aria-disabled={isDisabled}
        onclick={shiftLineToNextEvent}>
        <i class="bi bi-arrow-bar-down" aria-hidden="true"></i>
        <sub aria-hidden="true"><i class="bi bi-fonts"></i></sub>
    </a>
</li>
